var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9788 13.55L30.6353 0H27.8727L17.7518 11.765L9.66775 0H0.34375L12.5682 17.791L0.34375 32H3.10625L13.7948 19.5758L22.3318 32H31.6558L18.978 13.55H18.9788ZM15.1953 17.9475L13.9565 16.176L4.1015 2.0795H8.3445L16.2973 13.456L17.5357 15.2275L27.874 30.015H23.6315L15.1953 17.9482V17.9475Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.cc1921aad5b047a28a93a238d42c03cd.svg";
export { ForwardRef as ReactComponent };